import React, {useState} from 'react';
import {Row, Tabs} from 'antd';

// Components
import ContainerShipment from "../containerShipment/containerShipment/ContainerShipment";
import Planning from './schedule/Planning';


const ContainerShpmentsTabs = () => {
  const [activeKey, setActiveKey] = useState<string>("1");

  return (
    <Row>
      <Tabs key={activeKey}
            defaultActiveKey={activeKey}
            className={'overflow-x-auto'}
            onChange={setActiveKey}>
        <Tabs.TabPane tab={"Contenedores"} key={"1"}>
          <ContainerShipment />
        </Tabs.TabPane>
        <Tabs.TabPane tab={"Calendario"} key={"2"}>
          <Planning />
        </Tabs.TabPane>
      </Tabs>
    </Row>
  );
}

export default ContainerShpmentsTabs;